var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/sorting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/sorting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1111111,6 C19.6017795,6 20,6.22399902 20,6.5 L20,7.5 C20,7.77600098 19.6017795,8 19.1111111,8 L4.88888889,8 C4.39822049,8 4,7.77600098 4,7.5 L4,6.5 C4,6.22399902 4.39822049,6 4.88888889,6 L19.1111111,6 Z M17.1428571,11 C17.6160017,11 18,11.223999 18,11.5 L18,12.5 C18,12.776001 17.6160017,13 17.1428571,13 L6.85714286,13 C6.38399833,13 6,12.776001 6,12.5 L6,11.5 C6,11.223999 6.38399833,11 6.85714286,11 L17.1428571,11 Z M15.2,16 C15.6416016,16 16,16.223999 16,16.5 L16,17.5 C16,17.776001 15.6416016,18 15.2,18 L8.8,18 C8.35839844,18 8,17.776001 8,17.5 L8,16.5 C8,16.223999 8.35839844,16 8.8,16 L15.2,16 Z",
    id: "sorting",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.bc373f6b.svg";
export { ForwardRef as ReactComponent };